export default __webpack_public_path__ + "static/media/menu2.9cf2c835.png";